// @ts-nocheck
import * as React from "react";

const LogOut: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M7 4a1 1 0 1 1 0 2H6v12h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1V5l.007-.117A1 1 0 0 1 5 4Zm9.717 3.115A1 1 0 0 1 18 7.42l2.82 4a1 1 0 0 1-.02 1.18l-3 4a1 1 0 0 1-.8.4l-.129-.008a1 1 0 0 1-.471-.192l-.096-.081A1 1 0 0 1 16.2 15.4L18 13h-8a1 1 0 1 1 0-2h8.09l-1.72-2.42a1 1 0 0 1 .24-1.4Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(LogOut);
